
eM.localeLookupBase = {/*stage:{
	 '55':{f:'en',v:'en_GB'},
	 '3':{f:'es',v:'es_ES'},
	 '75':{f:'fr',v:'fr_FR'},
	 '91':{f:'it',v:'it_IT'},
	 '38':{f:'de',v:'de_DE'},
	 '106':{f:'nl',v:'nl_NL'},
	 '20':{f:'sc',v:'en_GB', a:'sv_SE'},
	 '445':{f:'pt',v:'pt_PT'},
	 'c_PL':{f:'pl',v:'pl_PL'},
	 'cRO':{f:'ru',v:'ru_RU'},
	 'cSO':{f:'fi',v:'fi_FI'},
	 'cANZ':{f:'az',v:'en_GB',a:'en_AU'},
	 '20':{f:'sc',v:'sv_SE'},
	 //'20':{f:'sc',v:'da_DK'},
	 'cUS':{f:'en',v:'en_GB',a:'en_US',m_i:1},
	 'cGR':{f:'gr',v:'el_GR'},
	 'PSSdevforum':{f:'en',v:'en_GB',m_i:1}
	 },*/
	live : {
		'55' : {
			f : 'en',
			v : 'en_GB',
			lL : 'en-gb'
		},
		'3' : {
			f : 'es',
			v : 'es_ES'
		},
		'75' : {
			f : 'fr',
			v : 'fr_FR'
		},
		'91' : {
			f : 'it',
			v : 'it_IT'
		},
		'38' : {
			f : 'de',
			v : 'de_DE'
		},
		'106' : {
			f : 'nl',
			v : 'nl_NL'
		},
		'20' : {
			f : 'sc',
			v : 'en_GB',
			a : 'sv_SE'
		},
		'445' : {
			f : 'pt',
			v : 'pt_PT'
		},
		'cPL' : {
			f : 'pl',
			v : 'pl_PL'
		},
		'cRU' : {
			f : 'ru',
			v : 'ru_RU'
		},
		'cFI' : {
			f : 'fi',
			v : 'fi_FI'
		},
		'cANZ' : {
			f : 'az',
			v : 'en_GB',
			a : 'en_AU'
		},
		'20' : {
			f : 'sc',
			v : 'sv_SE'
		},
		//'20':{f:'sc',v:'da_DK'},
		'cUS' : {
			f : 'en',
			v : 'en_GB',
			a : 'en_US',
			m_i : 1
		},
		'cGR' : {
			f : 'gr',
			v : 'el_GR'
		},
		'PSSdevforum' : {
			f : 'en',
			v : 'en_GB',
			m_i : 1
		},
		'cAR' : {
			f : 'ar',
			v : 'ar_AE'
		},
		'cJP':{f:'ja',v:'ja_JP', m_i:1},
		'cTR':{f:'tr',v:'tr_TR'}
	},
	lithiumLookup : {
		'en-gb' : 'en_GB',
		'en' : 'en_GB',
		'es' : 'es_ES',
		'fr' : 'fr_FR',
		'it' : 'it_IT',
		'de' : 'de_DE',
		'nl' : 'nl_NL',
		'pt' : 'pt_PT',
		'pl' : 'pl_PL',
		'ru' : 'ru_RU',
		'fi' : 'fi_FI',
		'gr' : 'gr_GR',
		'ar' : 'ar_AE',
		'da' : 'da_DK',
		'ja' : 'ja_JP',
		'tr' : 'tr_TR'		
	}

};
//here we add an extra value if we don't want to use the v value for actual locale reference - v will remain, and be the default
//but, good to have the other - esp for the lang manager
//m_i = menu_ignore